import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Yellow time-stamp pill. 'tint' sits on white card surfaces; 'solid' sits on
 * top of images so it stays legible. The mockup's cs-yellow-150 token does
 * not exist in the shared preset yet, so the nearest existing yellows are used.
 */
DurationBadge.propTypes = {
  label: PropTypes.string,
  variant: PropTypes.oneOf(['tint', 'solid'])
};

export default function DurationBadge(props) {
  const { label, variant = 'tint' } = props;
  if (!label) return null;

  return (
    <span
      className={classNames(
        'inline-flex items-center h-[22px] border-2 border-white rounded-[10px] px-2',
        'font-semibold text-[13px] leading-4 tracking-[0.05px] text-black whitespace-nowrap',
        variant === 'solid' ? 'bg-cs-yellow-200' : 'bg-cs-yellow-100'
      )}
    >
      {label}
    </span>
  );
}
